import AppStoreContext from 'contexts/AppStoreContext';
import * as React from 'react';
import { Interaction } from 'records/interactions';

export type InteractionManagerValue = {
  deleteInteractions: (type: string) => Promise<void>;
  clearInteractions: () => Promise<void>;
  createInteraction: (interaction: Interaction) => Promise<void>;
  updateInteraction: (interaction: Interaction) => Promise<void>;
};

const InteractionManagerContext =
  React.createContext<InteractionManagerValue | null>(null);

export const InteractionManagerProvider = InteractionManagerContext.Provider;

export const AppInteractionManagerProvider: React.FC = ({ children }) => {
  const { actions: appActions } = React.useContext(AppStoreContext);

  const interactionManager: InteractionManagerValue = {
    deleteInteractions: async (type) => {
      await appActions.deleteInteractions(type);
    },
    clearInteractions: async () => {
      await appActions.clearInteractions();
    },
    createInteraction: async (interaction) => {
      await appActions.createInteraction(interaction);
    },
    updateInteraction: async (interaction) => {
      await appActions.updateInteraction(interaction);
    },
  };

  return (
    <InteractionManagerProvider value={interactionManager}>
      {children}
    </InteractionManagerProvider>
  );
};

export const useInteractionManager = (): InteractionManagerValue => {
  const interactionManager = React.useContext(InteractionManagerContext);

  if (interactionManager === null) {
    throw new Error(
      'useInteractionManager must be used within a InteractionManagerProvider'
    );
  }

  return interactionManager;
};
